import React, { useEffect, useState } from 'react';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';


const ReservasCalendar = ({ reservas, slotMinTime = "08:00:00", slotMaxTime = "22:00:00" }) => {
  const [view, setView] = useState(window.innerWidth < 640 ? "timeGridDay" : "timeGridWeek");

  useEffect(() => {
    const handleResize = () => {
      setView(window.innerWidth < 640 ? "timeGridDay" : "timeGridWeek");
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Mapear reservas a eventos de FullCalendar
  const events = reservas.map(reserva => {
    const fecha = typeof reserva.fecha === 'string' && reserva.fecha.includes('T')
      ? reserva.fecha.split('T')[0]
      : reserva.fecha;
    return {
      title: `${reserva.cancha?.nombre || 'Cancha'} - ${reserva.cliente?.name || ''}`,
      start: `${fecha}T${reserva.hora_inicio}`,
      end: `${fecha}T${reserva.hora_fin}`,
      backgroundColor: reserva.estado === 'confirmada' ? '#22c55e' : '#f59e42',
      borderColor: '#888'
    };
  });

  return (
    <div className="w-full overflow-x-auto">
      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin]}
        initialView={view}
        events={events}
        locale="es"
        height="auto"
        slotMinTime={slotMinTime}
        slotMaxTime={slotMaxTime}
        headerToolbar={{
          left: 'prev,next today',
          center: 'title',
          right: window.innerWidth < 640 ? '' : 'dayGridMonth,timeGridWeek,timeGridDay'
        }}
        dayMaxEventRows={true}
      />
    </div>
  );
};

export default ReservasCalendar;
